import { setConfig } from '@davidlloydleisure/common-js-frontend';
import type { PropsWithChildren } from 'react';
import React, { useEffect } from 'react';

import type { PageContext } from 'src/components/common/page-context';
import { SiteContext } from 'src/context/site-context';
import { trySetPreferredLanguageCookie } from 'src/cookies/cookie-types/preference-cookies';
import { getBynderCName, getBynderDomain, getCloudinaryCName } from 'src/helpers/config-helper';
import { pageContextToSiteConfig } from 'src/helpers/page-context-site-config';

type SiteProviderProps = PropsWithChildren<{
  pageContext: PageContext;
}>;

const SiteProvider: React.FC<SiteProviderProps> = (props) => {
  const { buildType, language, notFoundDirectoryNames } = props.pageContext;
  const is404Page = notFoundDirectoryNames !== undefined;

  const siteConfig = pageContextToSiteConfig(props.pageContext, is404Page);
  setConfig({
    bynderCName: getBynderCName(),
    bynderDomain: getBynderDomain(),
    cloudinaryCName: getCloudinaryCName(),
  });

  useEffect(() => {
    trySetPreferredLanguageCookie(buildType, language);
  }, [buildType, language]);

  return <SiteContext.Provider value={siteConfig}>{props.children}</SiteContext.Provider>;
};

export default SiteProvider;
